import Axios from 'axios'
import notify from 'devextreme/ui/notify'
import store from '@/store/store'
const SITE_URL = 'api/admin/sites';
const USERS_URL = 'api/admin/users';


export default {
    namespaced: true,
    state: {
        account: [],
        sites: [],
        users: [],
    },
    mutations: {
        setSites(state, sts) {
            state.sites = sts ? sts.sites : []
            state.account = [];

            state.account.push(sts ? sts.acct : {});
        },
        setUsers(state, usrs) {
            state.users = usrs ? usrs : []
        }
    },
    actions: {
        async getSites({ commit }, uid) {
            var str = store;
            str.dispatch('updateStat', true)
            //for test purposes we will allow a val param so we can get all or asigned site depending on the user type
            return Axios.get(SITE_URL + '?uid=' + uid)
                .then(response => {
                    commit('setSites', response.data)

                    str.dispatch('updateStat', false)
                    return;
                })
                .catch(err => {

                    str.dispatch('updateStat', false)
                    notify(err.message, 'error')
                })
        },
        async getUsers({ commit }, uid) {
            var str = store;
            str.dispatch('updateStat', true)

            return Axios.get(USERS_URL + '?uid=' + uid)
                .then(response => {
                    commit('setUsers', response.data);
                    str.dispatch('updateStat', false)
                    return;
                })
                .catch(err => {
                    str.dispatch('updateStat', false)
                    notify(err.message, 'error')
                });
        }

    },
    getters: {
        sites: state => state.sites,
        account: state => state.account,
        users: state => state.users
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/common/LinkDsg/customer.js